import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonInput,
  IonButton,
  IonList,
  IonNavLink,
  IonAccordion,
  IonAccordionGroup,
  IonCheckbox
} from '@ionic/react';
import { useParams } from 'react-router';
import React, { useState, useEffect, useRef } from 'react';
import Markdown from '../../components/Markdown';
import prefs from '@/controllers/preferences';
import { getModels, providerNeedsAPIKeyAndModel, llmProviderEndpoints } from '@/controllers/llm_client';
window.getModels = getModels;

const userRoles = ["Student", "Teacher", "Parent"]

const SettingsPage: React.FC = () => {
  const { name } = useParams<{ name: string; }>();

  const [userRole, setUserRole] = useState(userRoles[0]);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [userEmail, setUserEmail] = useState('');

  const [llmProvider, setLlmProvider] = useState('');
  const [showLLMExtra, setShowLLMExtra] = useState(false);
  const [llmApiKey, setLlmApiKey] = useState('');

  const [llmModel, setLlmModel] = useState('');
  const [llmModels, setLlmModels] = useState([]);

  const [sttProvider, setSttProvider] = useState('');
  const [showSttExtra, setShowSttExtra] = useState(false);
  const [sttApiKey, setSttApiKey] = useState('');

  const [sttModel, setSttModel] = useState('');
  const [sttModels, setSttModels] = useState([]);

  const [language, setLanguage] = useState('');

  const [shareConvolution, setShareConvolution] = useState(true);
  const [sharePublic, setSharePublic] = useState(false);

  const loaded = useRef(false);

  // LLM

  useEffect(() => {
    //if (!loaded.current) return;
    //loaded.current = true;
    setShowLLMExtra(providerNeedsAPIKeyAndModel(llmProvider))
    //set('llmProvider', llmProvider)

    const later = async () => {
      if (!llmApiKey) return;
      const models = await getModels(llmProvider, llmApiKey);
      if (!models) {
        setLlmModels([])
        setLlmModel('')
        return;
      }
      console.log(models);
      setLlmModels(models);
      setLlmModel(await prefs.get(llmProvider + 'Model') || models[0]);

      await prefs.set(llmProvider + 'ApiKey', llmApiKey);
    }
    later()
  }, [llmProvider, llmApiKey])

  useEffect(() => {
    const later = async () => {
      setLlmApiKey(await prefs.get(llmProvider + 'ApiKey'))
      setLlmModel(await prefs.get(llmProvider + 'Model'))
    }
    later()

  }, [llmProvider])

  useEffect(() => {
    const later = async () => {
      if (!llmModel) return;
      await prefs.set(llmProvider + 'Model', llmModel);
      console.log("setting llmModel", llmProvider, llmModel)
    }
    later();
  }, [llmProvider, llmModel])

  // STT

  useEffect(() => {
    setShowSttExtra(providerNeedsAPIKeyAndModel(sttProvider))

    const later = async () => {
      if (!sttApiKey) return;
      const models = await getModels(sttProvider, sttApiKey);
      if (!models) {
        setSttModels([])
        setSttModel('')
        return;
      }
      console.log(models);
      setSttModels(models);
      setSttModel(await prefs.get(sttProvider + 'Model') || models[0]);

      await prefs.set(sttProvider + 'ApiKey', sttApiKey);
    }
    later()
  }, [sttProvider, sttApiKey])

  useEffect(() => {
    const later = async () => {
      setSttApiKey(await prefs.get(sttProvider + 'ApiKey'))
      setSttModel(await prefs.get(sttProvider + 'Model'))
    }
    later()

  }, [sttProvider])

  useEffect(() => {
    const later = async () => {
      if (!sttModel) return;
      await prefs.set(sttProvider + 'Model', sttModel);
      console.log("setting sttModel", sttProvider, sttModel)
    }
    later();
  }, [sttProvider, sttModel])

  // init defaults
  useEffect(() => {
    const load = async () => {
      setLlmProvider(await prefs.get("llmProvider"))
      setSttProvider(await prefs.get("sttProvider"))
      setLanguage(await prefs.get("language"))
      setTimeout(() => {loaded.current = true}, 100);
    };
    load();
  },[])

  const handleResetSettings = () => {

  };

  const handleResetData = () => {

  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name || 'Settings'}</IonTitle>
          <IonButtons slot="end">
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name || 'Settings'}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonList>
          <IonItem lines="none" className="bg-transparent">
            <IonLabel className="w-full">
              <div className="font-bold text-xl mb-2">
                User Profile Setup
              </div>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel>Role</IonLabel>
            <IonSelect interface="popover" value={userRole}
              onIonChange={(e) => {
                setUserRole(e.detail.value)
                prefs.set('userRole', e.detail.value)}
              }
            >
              {userRoles.map(x => (
                <IonSelectOption key={x} value={x}>{x}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>
          <IonItem className="flex">
            <IonLabel className="flex-1">Name</IonLabel>
            <IonInput
              className="flex-1 border-b-2 mb-2 border-stone-700 focus:border-violet-100"
              value={username}
              onIonInput={(e) => setUsername(e.detail.value!)}
              placeholder='Enter name...'
            ></IonInput>
          </IonItem>
          <IonItem className="flex">
            <IonLabel className="flex-1">Password</IonLabel>
            <IonInput
              className="flex-1 border-b-2 mb-2 border-stone-700 focus:border-violet-100"
              value={password}
              onIonInput={(e) => setPassword(e.detail.value!)}
              placeholder='Enter password...'
              type="password"
            ></IonInput>
          </IonItem>
          <IonItem className="flex">
            <IonLabel className="flex-1">Email</IonLabel>
            <IonInput
              className="flex-1 border-b-2 mb-2 border-stone-700 focus:border-violet-100"
              value={userEmail}
              onIonInput={(e) => setUserEmail(e.detail.value!)}
              placeholder='Enter email...'
            ></IonInput>
          </IonItem>

          <IonItem lines="none" className="bg-transparent">
            <IonLabel className="w-full">
              <div className="font-bold text-xl mb-2">
                LLM Provider Setup
              </div>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel>LLM Provider</IonLabel>
            <IonSelect interface="popover" value={llmProvider}
              onIonChange={(e) => {
                setLlmProvider(e.detail.value)
                prefs.set('llmProvider', e.detail.value)}
              }
            >
              {Object.keys(llmProviderEndpoints).map(provider => (
                <IonSelectOption key={provider} value={provider}>{provider}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>

          {showLLMExtra && (<>
          <IonItem lines="none" className="flex">
            <IonLabel className="flex-1">LLM API Key</IonLabel>
            <IonInput
              className="flex-1 border-b-2 mb-2 border-stone-700 focus:border-violet-100"
              value={llmApiKey}
              onIonInput={(e) => setLlmApiKey(e.detail.value!)}
              placeholder='Enter api key...'
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel className="w-full markdown">
              This key is stored locally, allowing you to choose your preferred LLM provider. 
              You can obtain it here: <a href="https://aistudio.google.com/apikey">https://aistudio.google.com/apikey</a>
            </IonLabel>
          </IonItem>

          <IonItem>
            <IonLabel>LLM Model</IonLabel>
            <IonSelect interface="popover" value={llmModel}
              onIonChange={(e) => setLlmModel(e.detail.value)}
            >
              {llmModels.map(model => (
                <IonSelectOption key={model} value={model}>{model}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>
          </>)}

          <IonItem lines="none" className="bg-transparent">
            <IonLabel className="w-full">
              <div className="font-bold text-xl mb-2">
                Speech to Text Provider Setup
              </div>
            </IonLabel>
          </IonItem>

          <IonItem>
            <IonLabel>STT Model Provider</IonLabel>
            <IonSelect interface="popover" value={sttProvider}
              onIonChange={(e) => {
                setSttProvider(e.detail.value)
                prefs.set('sttProvider', e.detail.value)}
              }
            >
              {Object.entries(llmProviderEndpoints).filter(([_,v]) => v.tts).map(([provider,_]) => (
                <IonSelectOption key={provider} value={provider}>{provider}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>

          {showSttExtra && (<>
          <IonItem lines="none" className="flex">
            <IonLabel className="flex-1">STT API Key</IonLabel>
            <IonInput
              className="flex-1 border-b-2 mb-2 border-stone-700 focus:border-violet-100"
              defaultValue={sttApiKey}
              placeholder='Enter api key...'
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel className="w-full markdown">
              This key is stored locally, enabling you to select your preferred speech transcription provider. 
              You can obtain it here: <a href="https://aistudio.google.com/apikey">https://aistudio.google.com/apikey</a>
            </IonLabel>
          </IonItem>

          <IonItem>
            <IonLabel>STT Model</IonLabel>
            <IonSelect interface="popover" value={sttModel}>
              {sttModels.map(model => (
                <IonSelectOption key={model} value={model}>{model}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>
          </>)}

          <IonItem lines="none" className="bg-transparent">
            <IonLabel className="w-full">
              <div className="font-bold text-xl mt-6 mb-2">
                Interface Setup
              </div>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel>Language</IonLabel>
            <IonSelect value={language} interface="popover" onIonChange={(e) => {
              setLanguage(e.detail.value)
              prefs.set_language(e.detail.value)
            }}>
              {Object.keys(prefs.languages).map(lang => (
                <IonSelectOption key={lang}>{lang}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>

          <IonItem lines="none" className="bg-transparent">
            <IonLabel className="w-full">
              <div className="font-bold text-xl mt-6 mb-2">
                Data
              </div>
            </IonLabel>
          </IonItem>

          <IonItem>
                <IonLabel className="w-full markdown">
                  <Markdown content={`
We invite you to help us enhance the program by sharing your data! 
Your contributions will be used privately to:
1. Better understand student responses to improve our anticipatory capabilities.
2. Analyze teacher model replies for ongoing enhancements.
3. Track user edits to the teacher model for further improvements.
4. Explore additional data to identify opportunities for service enhancement.

Furthermore, with your permission, we would love to share this data publicly (after thorough anonymization) with the wider community, such as through a Hugging Face dataset. This collaboration will enable even more significant improvements to our models by allowing a broader audience to benefit from them.`}
                  />
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonCheckbox checked={shareConvolution}>I agree to share my data with Convolution for the purpose of improving the program.</IonCheckbox>
              </IonItem>
              <IonItem>
                <IonCheckbox checked={sharePublic}>I consent to the anonymous public sharing of my data.</IonCheckbox>
              </IonItem>
        </IonList>
       

        <IonAccordionGroup>
        <IonAccordion>
          <IonItem slot="header" color="light">
          <IonLabel>
            Danger Zone
          </IonLabel>
        </IonItem>
        <div slot="content" className="ion-padding w-fit m-auto flex space-x-4 pt-20 mt-20">
          <IonButton color="warning" onClick={handleResetSettings}>Reset Settings</IonButton>
          <IonButton color="danger" onClick={handleResetData}>Delete All Data</IonButton>
        </div>
        </IonAccordion>
        </IonAccordionGroup>
      </IonContent>
    </IonPage>
  );
};

export default SettingsPage;
